import { fetchLast30Positions } from "@/api/position";

const state = {
  all: [],
  isLoading: false,
};

const actions = {
  cleanState({ commit }) {
    commit("cleanState");
  },

  async fetchLast30Positions({ dispatch, commit }, vehicleId) {
    try {
      dispatch(
        "overlay/show",
        { isShow: true, message: "Carregando últimas 30 posições ..." },
        { root: true }
      );
      commit("setLoading", true);

      const last30Positions = await fetchLast30Positions(vehicleId);

      commit("setAll", last30Positions);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    } finally {
      dispatch("overlay/show", false, { root: true });
      commit("setLoading", false);
    }
  },
};

const mutations = {
  setAll(state, lastPositions) {
    state.all = lastPositions;
  },

  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },

  cleanState(state) {
    state.all = [];
    state.isLoading = false;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
